import { $host } from ".";

export const createDoctor = async (doctorData) => {
    try {
        const { data } = await $host.post('api/doctor', doctorData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        console.error("Error creating doctor:", error);
        return error;
    }
};

export const fetchDoctors = async () => {
    try {
        const { data } = await $host.get('api/doctor');
        return data;
    } catch (error) {
        console.error("Error fetching doctors:", error);
        return error;
    }
};

export const fetchDoctor = async (id) => {
    try {
        const { data } = await $host.get('api/doctor/' + id);
        return data;
    } catch (error) {
        console.error("Error fetching a doctor:", error);
        return error;
    }
};

export const updateDoctor = async (id, updatedDoctor) => {
    try {
        const { data } = await $host.put('api/doctor/' + id, updatedDoctor, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        console.error("Error updating a doctor:", error);
        return error;
    }
};

export const deleteDoctor = async (id) => {
    try {
        const { data } = await $host.delete('api/doctor/' + id);
        return data;
    } catch (error) {
        console.error("Error deleting a doctor:", error);
        return error;
    }
};
